const CryptoJS = require("crypto-js");

import axios from 'axios'
import {Message} from 'element-ui';
import qs from 'qs'
import {urlcode} from "@/config.js"
import {hideLoading, showLoading} from "@/utils/loading";


//false为线上环境，true为本地环境
let isVip = true;

function checkStatus(response) {
  // loading
  // 如果http状态码正常，则直接返回数据
  if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
    return response
    // 如果不需要除了data之外的数据，可以直接 return response.data
  }
  // 异常状态下，把错误信息返回去
  return {
    status: -404,
    msg: '网络异常'
  }
}

function checkCode(res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res.status === 404) {
    console.log('网络错误，服务器错误，后端抛出的错误')
  }
  return res;
}

function returnError(res) {
  return res;
}

export default {
  post(url, data, isJson) {
    if (!isJson) {
      isJson = true;
    }
    // console.log('url',url)
    const token = sessionStorage.getItem('token')
    let newurl = url.trim()
    let dataParams;
    isJson ? dataParams = data : dataParams = data;
    let requireHeader;
    if (token) {
      requireHeader = {
        'Content-Type': isJson ? "application/json;" : 'application/x-www-form-urlencoded; charset=UTF-8',
        // "Content-Type":"application/json;",
        // 'Access-Token': token
        'Card-Access-Token': token
      }
    } else {
      requireHeader = {
        'Content-Type': isJson ? "application/json;" : 'application/x-www-form-urlencoded; charset=UTF-8',
      }
    }
    // console.log(requireHeader)
    url = urlcode + newurl

    return axios({
      withCredentials: true,
      crossDomain: true,
      method: 'post',
      //  baseURL: '',
      url,
      data: dataParams,
      timeout: 50000,
      /*      transformResponse: [data => {
              var JSONbig = require('json-bigint');
              data = JSONbig.parse(data);
              if (data.result.sysUser) {
                data.result.sysUser.id = data.result.sysUser.id.toString();
              }
              return data;
            }],*/
      headers: requireHeader
    }).then(
      (res) => {
        if (res.status === 200) {
          return checkCode(res)
        } else {
          this.loading = false
          this.$message.error(res.data.message)
          return checkCode(res)
        }

      }
    ).catch(res => {
      // console.log(res)
      this.loading = false
      Message({
        showClose: true,
        message: JSON.stringify(res),
        type: 'error'
      })
      if (res.code === 401) {
        sessionStorage.removeItem('token')
      }
      return returnError(res)
    })
  },
  get(url, params, url2) {
    // showLoading()
    let requireHeader;
// const headerAuth = sessionStorage.getItem('headerAuth')
    const token = sessionStorage.getItem('token')
    if (token) {
      requireHeader = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        // 'Access-Token': token
        'Card-Access-Token': token
      };
    } else {
      requireHeader = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      };
    }
    let newurl = url.trim()
    url = urlcode + newurl
    return axios({
      withCredentials: true,
      crossDomain: true,
      method: 'get',
      // baseURL: '',
      url,
      params, // get 请求时带的参数
      timeout: 50000,
      headers: requireHeader,
      /*transformResponse: [data => {
        var JSONbig = require('json-bigint');
        data = JSONbig.parse(data);
        if (url.indexOf("/sys/dict/list") > -1) {
          for (const index in data.result.records) {
            data.result.records[index].id = data.result.records[index].id.toString();
          }
        }
        return data;
      }]*/
      // responseType: "blob"
    }).then((res) => {
        // hideLoading()
        if (res.status === 200) {
          try {
            if (res.hasOwnProperty('data')) {
              if (res.data.hasOwnProperty('result')) {
                let result = res.data.result;
                for (const key in result) {
                  // console.log(155, url, typeof result[key])
                  if (typeof result[key] === 'number' && key !== 'total') {
                    result[key] = String(result[key])
                  }
                }
                res.data.result = result
              }
            }
          } catch (e) {
            console.log(37, e)
          }
          return checkCode(res)
        } else {
          this.loading = false
          this.$message.error(res.data.message)
          return checkCode(res)
        }
      }
    ).catch((res) => {
      // hideLoading()
      this.loading = false
      Message({
        showClose: true,
        message: JSON.stringify(res),
        type: 'error'
      })
      if (res.code === 401) {
        sessionStorage.removeItem('token')
      }
    })
  },
  put(url, data, isJson) {
    if (!isJson) {
      isJson = true;
    }
    showLoading()
    const token = sessionStorage.getItem('token')
    let newurl = url.trim()
    let dataParams;
    isJson ? dataParams = data : dataParams = qs.stringify(data)
    let requireHeader;
    if (token) {
      requireHeader = {
        'Content-Type': isJson ? "application/json;" : 'application/x-www-form-urlencoded; charset=UTF-8',
        // "Content-Type":"application/json;",
        // 'Access-Token': token
        'Card-Access-Token': token
      }
    } else {
      requireHeader = {
        'Content-Type': isJson ? "application/json;" : 'application/x-www-form-urlencoded; charset=UTF-8',
      }
    }
    url = urlcode + newurl

    return axios({
      withCredentials: true,
      crossDomain: true,
      method: 'put',
      //  baseURL: '',
      url,
      data: dataParams,
      timeout: 50000,
      headers: requireHeader
    }).then((res) => {
        hideLoading()
        if (res.status === 200) {
          return checkCode(res)
        } else {
          this.loading = false
          /*Message({
            message: res.data.message,
            type: 'error',
            duration: 2000
          })*/
          this.$message.error(res.data.message)
        }
      }
    ).catch(res => {
      hideLoading()
      // console.log(res)
      this.loading = false
      Message({
        showClose: true,
        message: JSON.stringify(res),
        type: 'error'
      })
      if (res.code === 401) {
        sessionStorage.removeItem('token')
      }

      return returnError(res)
    })
  },
  delete(url, params, url2) {
    showLoading()
    const token = sessionStorage.getItem('token')
    let requireHeader;
    if (token) {
      requireHeader = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        // 'Access-Token': token
        'Card-Access-Token': token
      }

    } else {
      requireHeader = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      }
    }
    let newurl = url.trim()
    url = urlcode + newurl
    return axios({
      withCredentials: true,
      crossDomain: true,
      method: 'delete',
      // baseURL: '',
      url,
      params, // get 请求时带的参数
      timeout: 50000,
      headers: requireHeader
    }).then((res) => {
        hideLoading()
        if (res.status === 200) {
          return checkCode(res)
        } else {
          this.loading = false
          this.$message.error(res.data.message)
        }
      }
    ).catch((res) => {
      hideLoading()
      this.loading = false
      Message({
        showClose: true,
        message: JSON.stringify(res),
        type: 'error'
      })
      if (res.code === 401) {
        sessionStorage.removeItem('token')
      }
    })
  },

  getIPMac() {
    return axios({
      method: 'get',
      url: 'http://localhost:5555/data',
      timeout: 1000,
    }).then(
      (res) => {
        const key = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC9kWla7+lfSE6RgtfwVTEoIrvCd1JZSfsuhz6Ic2YrIkk2zAkcC4Uvu3ui5/QGbP/ONr9bGmoS3GX6T2+DDM97qsPDdZZhtt48RdEWCj7juzCajGxpQ33oZISQXLLfYE4XHsi1HCV6b4arf3TBpgZaFY1M+BVM18Y9kDqEaAh5wQIDAQAB'
        return JSON.parse(decrypt(res.data, key))
      }
    ).catch((res) => {
      // console.log(33, res)
      // alert("当前计算机未经授权，请下载安装插件！")
      /*this.$alert('当前计算机未经授权，请确认是否下载安装插件！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
              this.$message({
                  type: 'info',
                  message: `action: ${action}`
              });
          }
      });*/
    })
  }
}


function decrypt(message, KEY) {
  let data = CryptoJS.enc.Hex.parse(message);
  const key = CryptoJS.enc.Utf8.parse(KEY);
  const option = {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  };
  let srcs = CryptoJS.enc.Base64.stringify(data);
  const words = CryptoJS.AES.decrypt(srcs, key, option);
  return words.toString(CryptoJS.enc.Utf8).toString();
}



// WEBPACK FOOTER //
// ./src/utils/request.js